import {React, useEffect, useState, useRef} from 'react'
import {BiChevronDown} from 'react-icons/bi'

const BasicSelector = ({
    listItem ,
    children,
    border=true,
    setOpenList: setOpenListProp,
    openList: openListProp,
    onSelected,
    label,
    defaultValue, 
    withArrow = true,
    withChangeLabel = true,
    size = 'sm',
    className,
    listOffsetX = 0
    }) => {
    const [listLabel,setListLabel] = useState(label) 
    const [openListState,setOpenListState] = useState(false)
    const dropdownRef = useRef(null);
    const openList = typeof openListProp === 'boolean' ? openListProp : openListState
    const setOpenList = typeof setOpenListProp === 'function' ? setOpenListProp : setOpenListState
    const isRTL = typeof document !== 'undefined' && document?.documentElement?.dir === 'rtl';
    let customStyle ;
    
    if(border){
        customStyle = ` bg-slate-50 border rounded px-3 py-1 shadow-sm `
    }
    
    useEffect(() => {
        setListLabel(label);
    }, [label]);

    useEffect(() => {
        if (!withChangeLabel) return;
        if (!defaultValue || !listItem || listItem.length === 0) return;
        const matched = listItem.find((item) => item.value === defaultValue || item.label === defaultValue);
        if (!matched) return;
        if (matched.label !== listLabel) {
            setListLabel(matched.label);
        }
    }, [defaultValue, listItem, withChangeLabel, listLabel]);



    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenList(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [setOpenList]);

    return (
        <div ref={dropdownRef} className={`relative flex flex-col ${border ? 'px-3' : ''} ${className}`}>
            <div 
                onClick={ ()=>  setOpenList(!openList)}
                className={`cursor-pointer text-xs flex items-center justify-between whitespace-nowrap transition-all hover:text-indigo-500 gap-2 ${size ==='lg' ? 'h-10 text-sm' : 'text-[15px]'} ${customStyle}`} >
                { children} {label && listLabel}
                { withArrow && <BiChevronDown /> }
            </div>
            {
                listItem && 
                <ul 
                    className={`absolute min-w-full w-max text-xs rounded-md top-full mt-1 z-[9999] bg-white shadow-lg border transition-all transform list-none ${openList && listItem.length > 0 ? 'scale-100 opacity-100' : 'scale-95 opacity-0 pointer-events-none'} `}
                    style={{
                        ...(isRTL ? { left: 0, right: 'auto' } : { right: 0, left: 'auto' }),
                        ...(listOffsetX ? (isRTL ? { marginRight: listOffsetX } : { marginLeft: listOffsetX }) : {})
                    }}
                >
                    {
                        listItem?.map((item,index) => (
                            <li 
                                onClick={
                                    () => {
                                        onSelected(item);
                                        setOpenList(false);
                                        if (withChangeLabel) {
                                            setListLabel(item.label);
                                        }
                                    }
                                }
                                key={index}
                                className={`cursor-pointer text-md p-3 text-[#251658] hover:bg-gray-100 z-50 transition ${listItem.length > 0 && listItem.length !== index+1 && 'border-b'}`}
                                >
                                <div className="flex items-center gap-2">
                                    {item.icon && <span className="text-base">{item.icon}</span>}
                                    <span>{item.label}</span>
                                </div>
                            </li>
                        ))
                    }
                </ul>
            }
        </div>
    )
}

export default BasicSelector
